<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'storage-flow.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-flow.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-flow.products' | transloco }}</small>
              <hx-product-info-select [(ngModel)]="params.productInfoIds" [multiple]="true" [types]="types" [brandId]="brandId" [disabled]="!brandId"></hx-product-info-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-flow.payment' | transloco }}</small>
              <hx-enum-select [(ngModel)]="params.paymentTypes" enumName="PaymentType" [enumType]="PaymentType" [multiple]="true"></hx-enum-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-flow.categories' | transloco }}</small>
              <hx-product-category-select [(ngModel)]="params.categoryIds" [multiple]="true" [brandId]="brandId"></hx-product-category-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-flow.limit' | transloco }}</small>
              <ng-select [items]="limits" bindLabel="id" bindValue="id" placeholder=""
                         [(ngModel)]="params.limit"></ng-select>
            </div>
          </div>

          <button type="button" (click)="reset()" class="btn btn-outline-success m--margin-top-15 m--margin-right-10">
            {{ 'reset.list' | transloco }}
          </button>

          <button type="button" (click)="applyFilters()" class="btn btn-outline-primary m--margin-top-15"
                  [disabled]="isLoading.list" [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.list}">
            {{ 'search' | transloco }}
          </button>

          <hr>

          <div *ngIf="storageFlowList.length && !isLoading.list" class="block-table-scroll">
            <table>
              <thead>
              <tr class="fixed-head-oline">
                <th class="text-center fixed-head-one" rowspan="2">{{ 'storage-flow.table.head.name' | transloco }}</th>
                <th class="text-center fixed-head-two" rowspan="2">{{ 'storage-flow.table.head.unit' | transloco }} <br>{{ 'storage-flow.table.head.change' | transloco }}</th>
                <th class="text-center fixed-head-three" rowspan="2">{{ 'storage-flow.table.head.remainder' | transloco }} <br>{{ 'storage-flow.table.head.beginning' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'storage-flow.table.head.release' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'storage-flow.table.head.posting' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'storage-flow.table.head.import' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'storage-flow.table.head.export' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'storage-flow.table.head.writeOff' | transloco }}</th>
                <th class="text-center" colspan="2">{{ 'storage-flow.table.head.order' | transloco }}</th>
                <th class="text-center" colspan="2">{{ 'storage-flow.table.head.production' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'storage-flow.table.head.remainder' | transloco }} <br>{{ 'storage-flow.table.head.finally' | transloco }}</th>
              </tr>
              <tr class="fixed-head-tline">
                <th>{{ 'storage-flow.table.head.implementation' | transloco }} </th>
                <th>{{ 'storage-flow.table.head.return' | transloco }} </th>
                <th>{{ 'storage-flow.table.head.used' | transloco }} </th>
                <th>{{ 'storage-flow.table.head.produced' | transloco }} </th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let storageFlow of storageFlowList">
                <tr>
                  <td class="tbody-fixed-one">{{ storageFlow.title | uiLabel }}</td>
                  <td class="tbody-fixed-two">{{ storageFlow.uomTitle  | uiLabel }}</td>
                  <td class="tbody-fixed-three">{{ storageFlow.startBalance }}</td>
                  <td>{{ storageFlow.invReceive }}</td>
                  <td>{{ storageFlow.purchase }}</td>
                  <td>{{ storageFlow.importProduct }}</td>
                  <td>{{ storageFlow.exportProduct }}</td>
                  <td>{{ storageFlow.discard }}</td>
                  <td>{{ storageFlow.receive }}</td>
                  <td>{{ storageFlow.refund }}</td>
                  <td>{{ storageFlow.add }}</td>
                  <td>{{ storageFlow.revoke }}</td>
                  <td>{{ storageFlow.endBalance }}</td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
          <hx-loader [length]="storageFlowList.length" [isLoading]="isLoading.list"></hx-loader>
          <br/>
          <br/>

          <div class="m--align-center" *ngIf="storageFlowList.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

